<ng-container *ngIf="!(surveyViewerService.haveRules$|async)?.questions?.length">

  <div class="mt-10 flex justify-center items-center">
    <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6 mr-2 text-gray-700" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
      <path stroke-linecap="round" stroke-linejoin="round" d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
    </svg>
    <span class="text-xl font-semibold">No rules based on questions</span>
  </div>

</ng-container>
<ng-container *ngFor="let aQuestionId of (surveyViewerService.haveRules$|async)?.questions">
  <app-survey-question
    [ngClass]="{'basis-2/3': true}"
    [question]="(surveyViewerService.activeSurvey$|async).questions[aQuestionId]"
    [isSmallScreen]="true"
    [activeLang]="translateService.getActiveLang()"
    [displayChat]="false"
    [surveyId]="(surveyViewerService.activeSurvey$|async).id"
  ></app-survey-question>
</ng-container>

